import axios from "@/api/axiosInstance";
import { DeleteStageResponse } from "./types";

export const deleteStage = async (
  uuid: string,
): Promise<DeleteStageResponse> => {
  const response = await axios.delete<DeleteStageResponse>(
    `/api/private/admin/stages/${uuid}`,
  );
  return response.data;
};
